import StickyPanelAPI from './sticky-panel-api';

export default StickyPanelAPI;
